import React, { useEffect, useState } from "react";
import "./SectorPerformance.css";
import { environment } from "environment/environment";
import useStockApiWebsocket from "service/websocket/StockApiWebsocket";

export default function SectorPerformance() {

    // WebSocket connection
    const { sectorialIndicesData } = useStockApiWebsocket(
        environment.stockApiDayRangeDataWSUrl
    );

    const [chartData, setChartData] = useState([]);

    // Selected sector state
    const [selectedStocks, setSelectedStocks] = useState([]);
    const [selectedSector, setSelectedSector] = useState("");

    /* ================== DATA MAPPING ================== */
    const buildSectorChartData = (data) => {
        if (!Array.isArray(data)) return [];

        return data.map((item) => {
            const cleanName = item.index
                ?.replace("NIFTY ", "")
                ?.replace("SECTOR ", "")
                ?.trim();

            return {
                name: cleanName,
                value: parseFloat(item.pChange) || 0,
                animatedHeight: 0,
                original: item
            };
        }).sort((a, b) => b.value - a.value);
    };

    /* ================== EFFECT ================== */
    useEffect(() => {
        if (Array.isArray(sectorialIndicesData) && sectorialIndicesData.length > 0) {

            const formatted = buildSectorChartData(sectorialIndicesData);

            // Step 1: initial height = 0
            setChartData(formatted);

            // Step 2: animate from bottom → top
            setTimeout(() => {
                const max = Math.max(...formatted.map(i => Math.abs(i.value))) || 1;

                setChartData(prev =>
                    prev.map(item => ({
                        ...item,
                        animatedHeight: (Math.abs(item.value) / max) * 300 // 🔥 dynamic scaling
                    }))
                );
            }, 100);
        }
    }, [sectorialIndicesData]);

    /* ================== CLICK HANDLER ================== */
    const handleBarClick = (item) => {

        // Toggle logic
        if (selectedSector === item.name) {
            setSelectedSector("");
            setSelectedStocks([]);
            return;
        }

        const stocks = item.original?.sectorialIndicesStockModelList || [];

        setSelectedStocks(stocks);
        setSelectedSector(item.name);
    };

    /* ================== UI ================== */
    return (
        <div className="sector-performance">

            {/* HEADER */}
            <div className="sector-header">
                <h2 className="sector-heading">
                    <span className="sectorial-indices-span">SECTOR PERFORMANCE</span>
                </h2>
            </div>

            {/* ================== CHART ================== */}
            <div className="sector-chart">
                {chartData.map((item, index) => {
                    const isPositive = item.value >= 0;

                    return (
                        <div
                            className={`bar-wrapper ${selectedSector === item.name ? "active" : ""}`}
                            key={index}
                            onClick={() => handleBarClick(item)}
                        >

                            {/* VALUE */}
                            <div className="value">
                                {item.value > 0 ? "+" : ""}
                                {item.value.toFixed(2)}%
                            </div>

                            {/* BAR */}
                            <div
                                className={`bar ${isPositive ? "green" : "red"}`}
                                style={{
                                    height: `${item.animatedHeight}px`,
                                    transitionDelay: `${index * 0.05}s` // 🔥 stagger animation
                                }}
                            ></div>

                            {/* LABEL */}
                            <div className="label">{item.name}</div>

                        </div>
                    );
                })}
            </div>

            {/* ================== TABLE ================== */}
           {selectedStocks.length > 0 && (
    <div className="sector-table">

        <h3>{selectedSector} STOCKS</h3>
{/* <div className="sector-header">
                <h2 className="sector-heading">
                    <span className="sectorial-indices-span">{selectedSector} STOCKS</span>
                </h2>
            </div> */}
        <div className="table-responsive">
            <table className="custom-table">
                <thead>
                    <tr>
                        <th>SYMBOL</th>
                        <th>LTP</th>
                        <th>CHANGE</th>
                        <th>CHANGE %</th>
                        <th>HIGH</th>
                        <th>LOW</th>
                    </tr>
                </thead>

                <tbody>
                    {selectedStocks.map((stock, idx) => {
                        const change = stock.change || stock.netChange || 0;
                        const changePercent = stock.pChange || 0;

                        return (
                            <tr key={idx}>
                                <td>
                                    {stock.symbol ||
                                        stock.sc_name ||
                                        stock.stockName}
                                </td>

                                <td>{stock.lastPrice}</td>

                                <td style={{ color: change >= 0 ? "green" : "red" }}>
                                    {change > 0 ? "+" : ""}
                                    {change}
                                </td>

                                <td style={{ color: changePercent >= 0 ? "green" : "red" }}>
                                    {changePercent > 0 ? "+" : ""}
                                    {changePercent}%
                                </td>

                                <td>{stock.high}</td>
                                <td>{stock.low}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>

    </div>
)}

        </div>
    );
}